<template>
    <v-row
        class="d-flex"
        justify="center"
        v-click-outside="closeCard"
        style="position: relative"
        @keydown.down="moveDown"
        @keydown.up="moveUp"
        @keydown.enter="goToItem"
    >
        <div style="display: flex; align-items: center; background-color: white; border-radius: 25px; padding: 8px 16px; width: 100%; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">
            <v-icon class="mr-2">mdi-magnify</v-icon>
            <input
                ref="input"
                v-model="search"
                type="text"
                placeholder="Search for Profiles, Groups, Protocols and Users"
                @focus="onFocus"
                @blur="searchFieldBlur"
                name="master-search"
                autocomplete="off"
                style="flex: 1; border: none; outline: none; font-size: 16px;"
            />
            <v-progress-circular v-if="isLoading" indeterminate size="20" width="2" class="ml-2" />
        </div>
        <v-expand-transition>
            <app-card
                v-if="showCard"
                class="master-search-menu"
                hide-header
            >
                <div v-if="!search && items.length === 0" class="pa-4">
                    Start typing to search your profiles, groups, protocols, and users
                </div>
                <div v-else-if="isLoading" style="padding: 20px; display: flex; justify-content: center; align-items: center;">
                    <v-progress-circular
                        indeterminate
                        color="primary"
                        :size="24"
                        :width="2"
                    ></v-progress-circular>
                    <span style="margin-left: 12px; color: #9CA3AF;">Searching...</span>
                </div>
                <div v-else-if="search && items.length === 0" class="pa-4" style="color: #757575;">
                    No results found for "{{ search }}"
                </div>
                <div v-else style="overflow: scroll">
                    
                    
                
                <v-list density="compact" style="max-height: 400px">
                    <v-list-item
                        v-for="(item, i) in items"
                        :key="i"
                        :class="['index-' + i, { 'v-list-item--active': selectedItemIndex === i }]"
                        @click="goToItem(item)"
                        :disabled="item.isHeader"
                        @mouseover="selectedItemIndex = i"
                    >
                        <template v-if="item.header">
                            <div class="pa-2">
                                <h2>{{item.header}}</h2>
                            </div>
                            <v-divider></v-divider>
                        </template>
                        <template v-else>
                            <v-list-item-title>{{ item.title }}</v-list-item-title>
                            <v-list-item-subtitle>{{ item.id }} ({{ item.organizationName }})</v-list-item-subtitle>
                        </template>
                    </v-list-item>
                </v-list>
                </div>
            </app-card>
        </v-expand-transition>
    </v-row>
</template>

<script>
import {masterSearch} from "@/services/organization.service";
import {switchSelectedOrganization, getOrgFromBrowserStorage} from "@/services/userService";

export default {
    name: "AppTestSearch2",
    data: () => ({
        search: null,
        showMenu: false,
        showCard: false,
        selectedItemIndex: 1,
        isLoading: false,
        items: [],
        searchTimeout: null,
    }),
    methods: {
        searchFieldBlur(event) {
            // this.search = ''
        },
        onFocus() {
            this.showCard = true;
        },
        closeCard() {
            this.showCard = false
        },
        moveDown() {
            if (this.items[this.selectedItemIndex + 1].isHeader) {
                
                this.selectedItemIndex += 2;
                console.log('isHeader. New index = ', this.selectedItemIndex)
            } else {
                this.selectedItemIndex++;
                console.log('is Not Header. New index = ', this.selectedItemIndex)
            }
            
            
            if (this.selectedItemIndex > 5) {
                this.scrollToElement(this.selectedItemIndex - 5)
            }
            
        },
        moveUp() {
            // this case should never happen but just in case           
            if (this.selectedItemIndex <= 1) return

            if (this.items[this.selectedItemIndex - 1].isHeader && this.selectedItemIndex > 1) {
                this.selectedItemIndex -= 2
            } else {
                this.selectedItemIndex--;
            }
            
            
            
            this.scrollToElement(this.selectedItemIndex)
        },
        scrollToElement(index) {
            const el = this.$el.getElementsByClassName(`index-${index}`)[0];

            if (el) {
                el.scrollIntoView({behavior: 'smooth'});
            }
        },
        async goToItem(item) {
            const target = item || this.items[this.selectedItemIndex];
            if (!target || !target.route) return;

            const currentOrg = getOrgFromBrowserStorage();
            if (target.orgId && currentOrg && String(target.orgId) !== String(currentOrg.id)) {
                const result = await switchSelectedOrganization(target.orgId);
                if (!result || (result.isSuccess && !result.selectedOrganization)) return;
            }

            this.$refs.input.blur();
            this.$router.push(target.route);
            this.showCard = false;
            this.search = '';
            this.searchTimeout = null;
        },
        myTest() {
            alert('my test')
        },
        async performSearch(val) {
            
            const response = await masterSearch(val);

            if (!response.isSuccess) {
                return
            }

            const {searchResults: results} = response

            // type 1 = Profile
            // type 2 = Group
            // type 3 = Protocol
            // type 4 = Account

            let profiles = [];
            let groups = [];
            let protocols = [];
            let accounts = [];

            results.forEach(result => {
                switch (result.type) {
                    case 1:
                        profiles.push(result);
                        break;
                    case 2:
                        groups.push(result);
                        break;
                    case 3:
                        protocols.push(result);
                        break;
                    case 4:
                        accounts.push(result)
                }
            })

            let final = [];
            if (profiles.length > 0) {
                let viewingAsSuper = this.$store.getters.viewingAsSuper;
                final.push({header: 'Profiles', isHeader: true})
                profiles.forEach(profile => {
                    final.push({
                        title: viewingAsSuper ? '' : profile.title,
                        id: profile.id,
                        orgId: profile.organizationId,
                        route: `/profiles/${profile.id}/overview?orgId=${profile.organizationId}`,
                        isHeader: false,
                        organizationName: profile.organizationName
                    })
                })
            }
            if (groups.length > 0) {
                final.push({header: 'Groups', isHeader: true})
                groups.forEach(group => {
                    final.push({
                        title: group.title,
                        id: group.id,
                        orgId: group.organizationId,
                        route: `/groups/${group.id}/profiles?orgId=${group.organizationId}`,
                        isHeader: false,
                        organizationName: group.organizationName
                    })
                })
            }
            if (protocols.length > 0) {
                final.push({header: 'Protocols', isHeader: true})
                protocols.forEach(protocol => {
                    final.push({
                        title: protocol.title,
                        id: protocol.id,
                        orgId: protocol.organizationId,
                        route: `/protocols/${protocol.id}?orgId=${protocol.organizationId}`,
                        isHeader: false,
                        organizationName: protocol.organizationName
                    })
                })
            }
            if (accounts.length > 0) {
                final.push({header: 'Accounts', isHeader: true})
                accounts.forEach(account => {
                    final.push({
                        title: account.title,
                        id: account.id,
                        orgId: account.organizationId,
                        route: `/users/${account.id}?orgId=${account.organizationId}`,
                        isHeader: false,
                        organizationName: account.organizationName
                    })
                })
            }

            this.items = final;
            this.isLoading = false;
            this.selectedItemIndex = 1;
        }
    },
    watch: {

        async search (val) {
            if (!val) return
            this.items = [];
            this.isLoading = true;
           

            if (this.searchTimeout) {
                clearTimeout(this.searchTimeout)
                // this.searchTimeout = null
                
            }
            
            this.searchTimeout = setTimeout(async () => {
        
                await this.performSearch(val)
            }, 250)
            
        },
    },
}
</script>

<style scoped>
.master-search-menu {
    position: absolute;
    max-height: 400px;
    width: 100%;
    z-index: 10;
    top: 60px;
    /*overflow: scroll;*/
}

.search-input-area {
    background-color: var(--v-light-lighten1);
    border-radius: 15px;

}
</style>